import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { supabase } from "@/lib/supabaseClient";

const initialState = {
  students: [],
  nonTechStudents: [],
  loading: false,
  error: null,
};

// 👉 Common sorting logic
const sortByPackage = (data) => {
  const extractNumber = (pkg) => {
    if (!pkg) return 0;
    const cleaned = pkg.replace(/,/g, "").match(/[\d.]+/);
    return cleaned ? parseFloat(cleaned[0]) : 0;
  };
  return data.sort(
    (a, b) => extractNumber(b.package) - extractNumber(a.package)
  );
};

// -----------------------------
// 🔥 FETCH TECH STUDENTS
// -----------------------------
export const fetchPlacedStudents = createAsyncThunk(
  "placements/fetchPlacedStudents",
  async (_, { rejectWithValue }) => {
    const { data, error } = await supabase.from("placed_students").select("*");

    if (error) return rejectWithValue(error.message);

    return sortByPackage(data || []);
  }
);

// -----------------------------
// 🔥 FETCH NON-TECH STUDENTS
// -----------------------------
export const fetchNonTechStudents = createAsyncThunk(
  "placements/fetchNonTechStudents",
  async (_, { rejectWithValue }) => {
    const { data, error } = await supabase
      .from("non_technical_placed")
      .select("*");

    if (error) return rejectWithValue(error.message);

    return sortByPackage(data || []);
  }
);

const placementsSlice = createSlice({
  name: "placements",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // =============================
      // 🔵 TECH STUDENTS
      // =============================
      .addCase(fetchPlacedStudents.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPlacedStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.students = action.payload;
        state.error = null;
      })
      .addCase(fetchPlacedStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // =============================
      // 🔵 NON-TECH STUDENTS
      // =============================
      .addCase(fetchNonTechStudents.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNonTechStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.nonTechStudents = action.payload;
        state.error = null;
      })
      .addCase(fetchNonTechStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default placementsSlice.reducer;
